export default "__VITE_PUBLIC_ASSET__33a7f91e__"